import { ReactNode, useContext } from 'react';
import clsx from 'clsx';

import WorkTemplateContext, {
  WorkTemplateView,
} from '@atom/components/workTemplate/WorkTemplateContext';

import classes from './workTemplateHeader.module.css';

export interface Props {
  view: {
    value: WorkTemplateView;
    label: string;
    icon: ReactNode;
  };
}

const WorkTemplateHeaderButton = ({ view }: Props) => {
  const { activeView, setActiveView } = useContext(WorkTemplateContext);

  return (
    <div
      onClick={() => setActiveView(view.value)}
      className={clsx(
        classes.iconContainer,
        activeView === view.value && classes.active,
      )}
    >
      <div className={classes.icon}>{view.icon}</div>
      <div className={classes.label}>{view.label}</div>
    </div>
  );
};

export default WorkTemplateHeaderButton;
